export default {"src":"/_next/static/media/green-check.c900fe75.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};